/**
 * Hands an authenticated fetch's CSV to the browser as a download.
 *
 * The API is Bearer-only, so a plain `<a href>` carries no credential and 401s.
 * The body is fetched through useClient instead, then saved through a throwaway
 * object URL and anchor, which is the standard way to download a response that
 * needed a header to get.
 */
type SaveCsvParams = { csv: string; filename: string };

export function saveCsv({ csv, filename }: SaveCsvParams) {
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
